import { useState } from 'react';

import QuadroVendedor from '../../components/QuadroVendedores/QuadroVendedores';
import NotifierPopup from '../../components/NotifierPopup/NotifierPopup';

export default function QuadroVendedores() {

    const [ notify, setNotify ] = useState({
        isActive: false,
        isSuccessful: undefined,
        message: undefined
    });


    return <>
        {notify.isActive && 
            <NotifierPopup 
                notify={notify}
                setNotify={setNotify}
            />
        }
        <QuadroVendedor  setNotifier = {(isSuccess, message) => setNotify({
                isActive: true,
                isSuccessful: isSuccess,
                message: message
            })} />
    </>
}